import { Pipe, PipeTransform } from '@angular/core';

import { GreenHouseMap } from '../../models';
import { mapRowPositions } from './constants';

@Pipe({
    name: 'mapRowPosition',
    standalone: true,
})
export class MapRowPositionPipe implements PipeTransform {
    transform(value: GreenHouseMap, rowPosition: mapRowPositions): boolean {
        switch (rowPosition) {
            case 'left':
                return value.centralPathRowSets.some((rowSet) => rowSet.left);
            case 'right':
                return value.centralPathRowSets.some((rowSet) => rowSet.right);
        }
    }
}
